export default __webpack_public_path__ + "static/media/calander.f6a2ae12.png";